export default "__VITE_ASSET__54b91329__"